import React, { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Form, Button, Card} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidate, addCandidateLanguage, deleteCandidateLanguage, getCandidateProfileStatus } from '../../actions/candidatesActions'
import Swal from 'sweetalert2'
import languages from "../../components/languages.json"
import Select from "react-select"
import SubMenuHabilities from '../../components/menus/SubMenuHabilities'
import { Link, useNavigate, useParams } from 'react-router-dom'

export default function Languages() {
    const {id: candidateId} = useParams() || {}
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [submitButton, setSubmitButton] = useState('submit');

    const titleFileInput = useRef(null)

    const {candidate, resultcandidate, candidateStatus} = useSelector(state=>state.candidates)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getCandidate(candidateId ||client?.id))
        }
    },[dispatch, t, client])

    const [languagesSelection, setLanguagesSelection] = useState({
        options: [],
        selected: null
    })

    const [levelSelection, setLevelSelection] = useState({
        options: [],
        selected: null
    })

    const [titleUrl, setTitleUrl] = useState(null)

    const [noLanguages, setNoLanguages] = useState(false)

    const handleAddCourse = async(e) => {
        e.preventDefault()
        let languagesOk = false

        if(!noLanguages){
            if(languagesSelection?.selected && levelSelection?.selected){
                languagesOk = true
            }
        }else{
            languagesOk = true
        }
        if(languagesOk){
            dispatch(addCandidateLanguage({language: languagesSelection.selected?.value, level: levelSelection.selected?.value, titleUrl: titleUrl, noLanguages: noLanguages}, candidateId ||client?.id))

            setLanguagesSelection({
                ...languagesSelection,
                options: languagesSelection.options.filter(l => l.value !== languagesSelection.selected.value),
                selected: null
            })
            setLevelSelection({
                options: [],
                selected: null
            })
            setTitleUrl(null)
            titleFileInput.current.value = null
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('profile.candidate.languagesConfig.errorLanguageLevel')
            })
        }
    }

    const handleDeleteLanguage = async(e, language) => {
        e.preventDefault()
 
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text: t('profile.candidate.areyousuredelete')
        }).then((resultuser) => {
            if (resultuser.isConfirmed) {
                dispatch(deleteCandidateLanguage(language, candidateId ||client?.id))
            }
        })
    }

    const handleLanguageChange = (selectedValue) => {
        setLanguagesSelection({
            ...languagesSelection,
            selected: selectedValue
        })

        setLevelSelection({
            options: languages.find(l => l.language === selectedValue.value)?.levels?.map(language => {
                return {label: language.name, value: language.name, certificate: language.certificate}
            }),
            selected: null
        })

        setNoLanguages(false)
    }

    useEffect(() => {
        if(resultcandidate){
            switch (resultcandidate) {
                case 'successAddLanguage':
                    dispatch(getCandidate(candidateId ||client?.id))
                    dispatch(getCandidateProfileStatus(candidateId ||client?.id))
                    if(submitButton==='submit'){
                        Swal.fire({
                            showConfirmButton: true,
                            showDenyButton: false,
                            confirmButtonText: t('global.great'),
                            icon: 'success',
                            text: t('profile.candidate.languagesConfig.successAddLanguage')
                        })
                    }else{
                        if(candidateId){
                            navigate('/admin/candidate/technologies/'+candidateId)
                        }else{
                            navigate('/candidate/profile/technologies')
                        }
                    }
                    break;
                case 'errorAddLanguage':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.languagesConfig.errorAddLanguage')
                    })
                    break;
                case 'successDeleteLanguage':
                    dispatch(getCandidate(candidateId ||client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.languagesConfig.successDeleteLanguage')
                    })
                    dispatch(getCandidateProfileStatus(candidateId ||client?.id))
                    break;
                case 'errorDeleteLanguage':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.languagesConfig.errorDeleteLanguage')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultcandidate])
    
    useEffect(() => {
        if (candidate) {
            setNoLanguages(candidate.noLanguages === null || candidate.noLanguages === undefined ? false : candidate.noLanguages)
            setLanguagesSelection({
                options: languages.filter(l => !candidate.languages.some(cl => cl.language === l.language)).map(language => {
                    return {label: language.language, value: language.language}
                }),
                selected: null
            })
        }
    }, [candidate])

    return (
        <Container className='cuerpo'>
            <Row className='mb-4'>
                <Col className='d-flex align-items-center'>
                    <img src="/images/habilidadesbig.svg" alt="Icono Habilidades" />
                    <h1 className='ms-2 m-0'>{t('menus.skills')}</h1>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    <Card className='mb-5 sombra lateral' >
                        <Card.Body className='p-0 d-flex'>
                            <div className='d-none d-sm-block submenu-lateral'>
                                    <SubMenuHabilities seccion='languages' usertype={candidateId ? 'Superadmin' : 'Candidate'} candidateId={candidateId}/>
                            </div>
                            <div className='px-5 py-3 contenido-datos'>
                                <Row className="mt-5 mb-3">
                                    <Col>
                                        <h3>{t('profile.candidate.languagesConfig.languages')}</h3>
                                    </Col>
                                </Row>
                                <Row className="mt-1 mb-3">                                        
                                    {candidate?.languages?.length > 0
                                        ?                                                    
                                            candidate?.languages?.map((language, key) => (
                                                <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center' key={key}>
                                                    <div className='d-flex'>
                                                        <div className='me-3'><img src="/images/diploma.svg" className='w-65px' alt="Diploma"/></div>
                                                        <div>
                                                            <h4 className='fw-bold'>{language.language}</h4>
                                                            {language.level}
                                                            </div>
                                                    </div>
                                                    <div>
                                                        {
                                                            language.titleUrl &&
                                                            <a href={language.titleUrl} download target="_blank" rel="noreferrer"><i className='fas fa-download'/></a>
                                                        }
                                                    
                                                        <img src="/images/trash.svg" className='ms-2 cursor' alt="Trash" onClick={e => handleDeleteLanguage(e, language._id)} />
                                                    </div>
                                                </Col>
                                            ))
                                        :
                                            <></>
                                    }
                                </Row>
                                <Form onSubmit={handleAddCourse} className='mt-1 mb-3'>
                                    <Row className='my-3'>
                                        <Col sm={6}>
                                            <Form.Label>{t('profile.candidate.languagesConfig.languageName')}</Form.Label>
                                            <Select
                                                className="select"
                                                onChange={handleLanguageChange}
                                                name="languageName"                                                    
                                                options={languagesSelection.options}
                                                value={languagesSelection.selected}
                                            />
                                        </Col>
                                        <Col sm={6}>
                                            <Form.Label>{t('profile.candidate.languagesConfig.level')}</Form.Label>
                                            <Select
                                                className="select"
                                                onChange={selectedValue => {setLevelSelection({...levelSelection, selected: selectedValue}); setNoLanguages(false);}}
                                                name="level"                                                    
                                                options={levelSelection.options}
                                                value={levelSelection.selected}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='my-3'>
                                        <Col sm={12}>
                                            <Form.Label>{t('profile.candidate.languagesConfig.titleFile')}</Form.Label>
                                            <Form.Control type='file' required={!noLanguages && (!levelSelection.selected || levelSelection.selected?.certificate) ? true : false} name='titleUrl' onChange={(e) => {setTitleUrl(e.target.files[0]); setNoLanguages(false);}} ref={titleFileInput} />
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='6'>
                                            <Button type="submit" className="btn-primary w-100 my-2" disabled={noLanguages}>
                                                {t('profile.candidate.languagesConfig.addLanguage')}
                                            </Button>
                                        </Col>
                                    </Row>
                                    {
                                        (!candidate?.languages || candidate?.languages.length === 0) &&
                                            <>
                                                <Row>
                                                    <Col xs={12} lg={6} className='my-3 ms-auto text-end'>
                                                        <Form.Label htmlFor='isUnexperienced' className='m-0'> {t('profile.candidate.noLanguages') }</Form.Label>
                                                        <div className='d-flex justify-content-end'>
                                                            <Form.Check
                                                                className="mx-2"
                                                                type="switch"
                                                                name="isUnexperienced"
                                                                id="isUnexperienced"
                                                                onChange={e => setNoLanguages(e.target.checked)}
                                                                checked={noLanguages}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                    }
                                    {
                                        noLanguages
                                        ?
                                            <Row className="my-3 d-flex justify-content-end">
                                                <Col xs='12' lg='6'>
                                                    <Button type="submit" onClick={e => setSubmitButton('continue')} className="btn-primary w-100 my-2">{(candidateStatus === '4.2') ? t('profile.candidate.saveAndContinue') : t('profile.candidate.editCompetences')}</Button>
                                                </Col>
                                            </Row>
                                        :
                                            candidate?.languages.length >0
                                            ?
                                                candidateStatus === '4.3'
                                                ?
                                                    <Row className="my-3 d-flex justify-content-end">
                                                        <Col xs='12' lg='6'>
                                                            <Link to="/candidate/profile/technologies" className="btn btn-primary w-100 my-2">{t('profile.candidate.saveAndContinue')}</Link>
                                                        </Col>
                                                    </Row>
                                                :   <></>
                                            :   <></>
                                    }
                                </Form>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}